export const DEFAULT_PAGINATION_LIMIT = 20
export const DETAILS_OVERLAY_SHOWN_WINDOW_WIDTH = 1700
export const CHANNEL_LIST_SHOWN_WINDOW_WIDTH = 1400
